<template>
<div class="warpper">
  <div class="login_container">
    <div class="container">
      <div class="login_content">
        <div id="loginreturn" v-show="!isHostTransport">
          <img class="cursor" src="../../assets/back.png" alt="" v-on:click="backToTrans()">
        </div>
        <div class="logo">
          <img src="../../assets/logo.png" alt="">
        </div>
        <span class="title">欢迎进入CDR-RST补货优化模型系统</span>
        <div class="user_content">
          <div class="user_select" id="user_select" v-show="isHostTransport">
            <button class="cursor ternal" id="internalUser" v-on:click="hostTransport(0)">使用NIKE内部账号登录</button>
            <button class="cursor ternal" id="outernalUser" v-on:click="hostTransport(1)">使用运动员外部账号登录</button>
            <div class="bottom_content">
              <p class="bottom_tips">推荐使用Chrome浏览器获得最佳体验</p>
              <a class="cursor" id="pagenumber" :href="companyRecordUrl" target="_blank">沪ICP备14009339号</a>
            </div>
          </div>

          <div class="user_login" id="user_login" v-show="!isHostTransport">
            <div class="form_input">
              <input type="text" placeholder="请输入账号" v-model="username" @keyup.enter="login()"/>
            </div>
            <div class="form_input">
              <input type="password" placeholder="请输入密码" v-model="password" @keyup.enter="login()">
            </div>
            <div class="btn_content">
              <button class="btn login_btn btn-radious cursor" v-on:click="login()">立即登录</button>
            </div>
          </div>
        </div>

        
        
      </div>
    </div>
  </div>
  <logintip v-if="ifShow && sendMessage.length > 0" v-bind:status="sendStatus" v-bind:message="sendMessage"></logintip>
  <Loading :stop="loadingShow"></Loading>
</div>
</template>

<script>
import { Login } from "../../util/api.js";
import Tip from "@/components/common/tip";
import Logintip from "@/components/common/logintip"
import Loading from "@/components/common/loading";
import { mapState, mapActions } from "vuex";
import {build} from "../../../config/index";
const path = require('path')
const envOkat = process.env.OKAT_LOGIN_URL;

export default {
  name: "Login",
  components: { Tip, Loading, Logintip},
  data() {
    return {
      username: "",
      password: "",
      sendStatus: false,
      sendMessage: "",
      isHostTransport: true,
      companyRecordUrl: "http://www.beian.miit.gov.cn",
      okta_login_url: envOkat,
      loadingShow: false,
    };
  },
  computed: mapState({
    ifShow: state => state.ifShowMessage
  }),
  methods: {
    setCookie(name, value, day){
      if(day !== 0){     //当设置的时间等于0时，不设置expires属性，cookie在浏览器关闭后删除
        var expires = day * 24 * 60 * 60 * 1000;
          var date = new Date(+new Date()+expires);
          document.cookie = name + "=" + value + ";expires=" + date.toUTCString();
      }else{
        document.cookie = name + "=" + value;
      }
    },
    hostTransport: function(type) {
      if(type == 0) {
        window.location.href = this.okta_login_url;
      } else {
        this.isHostTransport = false;
      }
    },
    backToTrans: function() {
      this.isHostTransport = true;
    },
    login: function() {
        this.loadingShow = false;
        const sendData = {
          external: 1,
          username: this.username,
          password: this.password
        };
       if(this.username == ''||this.password == ''){
         this.$store.commit("getIfShowMessage", true)
         this.sendStatus = false;
         this.sendMessage = "用户名或密码不能为空"
         return
       }
       this.sendLogin(sendData);
    },
    sendLogin: function(sendData) {
      let that = this;
      that.loadingShow = true;
      let res = Login(sendData)
        .then(function(res) {
          const result = JSON.parse(decodeURIComponent(res.data));

          if (result.status == 200) {
            that.setCookie("rstuserId", result.data.UserId,1);
            that.setCookie("rstuserName", result.data.Username,1);
            if(result.data.Authorities && result.data.Authorities.length != 0){
              that.setCookie('authority',result.data.Authorities[0].authority,1);
            }
            that.$router.push("settingDays");
          } else {
            that.$store.commit("getIfShowMessage", true);
            that.sendStatus = false;
            that.sendMessage = result.message ? result.message : "登录失败";
          }
          that.loadingShow = false;
        })
        .catch(function(error) {
          that.loadingShow = false;
          console.log(error);
        });
    }
  },
  mounted: function() {
    let that = this;
    that.$store.commit("getIfShowMessage", false);
  }
};
</script>


<style scoped>
* {
  box-sizing: border-box;
}
.login_container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  background: url(../../assets/login4.png) center no-repeat;
  background-size: cover;
}
.login_content {
    width: 5.16rem;
    height: 6.3rem;
    padding-top: 0.7rem;
    background-color: #e3e2e2;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    border-radius: 10px;
    opacity: 0.95;
}
.login_content #loginreturn{
    position: absolute;
    padding-left: 1em;
    top: 2em;
    width: 4em;
}

.title {
  font-size: 13px;
  display: block;
  line-height: 1;
  padding: 0.225rem 0 0.3rem 0;
  font-weight: bold;
  color: #000;
  margin-top: 0.3rem;
}
input,
select {
  width: 3.56rem;
  height: 39px;
  border: 1px solid #cfcfcf;
  margin-bottom: 14px;
  font-size: 0.15rem;
  padding: 0 17px;
  color: #000;
  border-radius: 3px;
  box-sizing: border-box;
  vertical-align: top;
}
select {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: url(../../assets/select_down.png) no-repeat 3.25rem;
  padding-right: 20px;
  background-color: #fff;
  z-index: 111;
  margin-bottom: 14px;
}
.btn_content {
  margin-top: 0.24rem;
  outline: none;
}
.login_btn {
  width: 3.55rem;
  height: 0.575rem;
  background-color: #262626;
  color: #fff;
  display: block;
  margin: 0 auto;
  border: 0;
  border-radius: 0.4rem;
}
.login_btn:hover,
.login_btn:focus {
  color: #fff;
}
.forget_pas {
  color: #808080;
  font-size: 0.15rem;
  margin-top: 0.287rem;
  display: block;
}
.err_hide {
  position: absolute;
  top: -60px;
  left: 50%;
  transform: translate(-50%, 0);
  background: #ff5b5b;
  padding: 10px;
  color: #fff;
  border-radius: 5px;
  transition: top 0.6s;
}
.err_tip {
  top: 0;
}
.form_input {
  height: 53px;
  margin-bottom: 15px;
}
.logo {
  height: 60px;
}
.logo img {
  vertical-align: top;
}

.cursor{
  cursor: pointer;
  text-decoration:none;
}

.user_content {
  margin-top: 4em;
  height: 18em;
}
.user_select{
	width: 100%;
	font-size:14px;
	font-weight:normal;
	color:rgba(255,255,255,1);
  margin: 3em 0;
}
.user_select .ternal{
  height: 0.5rem; 
	width: 70%;
  border-style: solid;
	border-radius: 0.25rem;
  margin-bottom: 3.5em;
	font-size:14px;
	font-weight:normal;
  color:rgba(255,255,255,1);
}
.user_select #internalUser{
	border-color: rgb(224, 121, 70);
  background-color: rgb(224, 121, 70);
}
.user_select #outernalUser{
	border-color: #000000;
   background-color: #000000;
}
.login_content .bottom_content{
	font-size:12px;
	font-family:Adobe Heiti Std;
	font-weight:normal;
  color:rgba(153,153,153,1);
  margin-top: 0.22rem;
}
.login_content .bottom_content #pagenumber{
	font-size:12px;
	font-family:Adobe Heiti Std;
	font-weight:normal;
	color:rgba(153,153,153,1);
}
.login_content .bottom_content .bottom_tips{
    margin-bottom: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Login.vue